import { RefObject, useMemo, useRef } from 'react';
import { usePopper as useBasePopper } from 'react-popper';

export type Popper = {
  referenceElement: React.RefObject<HTMLDivElement>;
  styles: { [key: string]: React.CSSProperties };
  attributes: { [key: string]: { [key: string]: string } | undefined };
  popperElement: RefObject<HTMLDivElement>;
};

export const usePopper = (): Popper => {
  const referenceElement = useRef<HTMLDivElement>(null);
  const popperElement = useRef<HTMLDivElement>(null);

  const modifiers = useMemo(
    () => [
      {
        name: 'offset',
        options: {
          offset: [0, 5],
        },
      },
      {
        name: 'preventOverflow',
        enabled: true,
        options: {
          tether: true,
          altBoundary: true,
        },
      },
      {
        name: 'flip',
        enabled: true,
      },
      {
        name: 'computeStyles',
        options: {
          gpuAcceleration: false,
        },
      },
    ],
    []
  );

  const { styles, attributes } = useBasePopper(
    referenceElement.current,
    popperElement.current,
    {
      placement: 'bottom-end',
      modifiers,
    }
  );

  return {
    referenceElement,
    styles,
    attributes,
    popperElement,
  };
};
